import { t } from "i18next";
import React from "react";
import styles from "./Geo.module.scss";

type Props = {
  locales: string[];
};
export const Locale: React.FC<Props> = ({ locales = [] }) => {
  return (
    <div className={styles["geo-row"]}>
      {locales.map((locale) => (
        <div className={styles["geo-item"]} key={locale}>
          <img
            src={`https://flagpedia.net/data/flags/icon/16x12/${locale
              .split("-")[1]
              ?.toLowerCase()}.png`}
            alt={locale}
          />
          {t(locale).replace(/-[a-z]+$/i, "")}
        </div>
      ))}
    </div>
  );
};
